// extracted by mini-css-extract-plugin
export default {"section":"notFound_section__VvOwZ","title":"notFound_title__CSI5B"};